module.exports = __webpack_public_path__ + "img/AerWorx_Favicon_20.ed1a17b0.png";